import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';

export const CREATE_CHAT = 'CREATE_CHAT';
export const CREATE_CHAT_SUCCESS = 'CREATE_CHAT_SUCCESS';
export const CREATE_CHAT_FAIL = 'CREATE_CHAT_FAIL';
export const CREATE_CHAT_RESET = 'CREATE_CHAT_RESET';

export const GET_CHAT = 'GET_CHAT';
export const GET_CHAT_SUCCESS = 'GET_CHAT_SUCCESS';
export const GET_CHAT_FAIL = 'GET_CHAT_FAIL';
export const GET_CHAT_RESET = 'GET_CHAT_RESET';

export const GET_ALL_CHATS = 'GET_ALL_CHATS';
export const GET_ALL_CHATS_SUCCESS = 'GET_ALL_CHATS_SUCCESS';
export const GET_ALL_CHATS_FAIL = 'GET_ALL_CHATS_FAIL';
export const GET_ALL_CHATS_RESET = 'GET_ALL_CHATS_RESET';

export const GET_CHATS_BY_PROJECT = 'GET_CHATS_BY_PROJECT';
export const GET_CHATS_BY_PROJECT_SUCCESS = 'GET_CHATS_BY_PROJECT_SUCCESS';
export const GET_CHATS_BY_PROJECT_FAIL = 'GET_CHATS_BY_PROJECT_FAIL';
export const GET_CHATS_BY_PROJECT_RESET = 'GET_CHATS_BY_PROJECT_RESET';

export const DELETE_CHAT = 'DELETE_CHAT';
export const DELETE_CHAT_SUCCESS = 'DELETE_CHAT_SUCCESS';
export const DELETE_CHAT_FAIL = 'DELETE_CHAT_FAIL';
export const DELETE_CHAT_RESET = 'DELETE_CHAT_RESET';

export const UPDATE_CHAT_TITLE = 'UPDATE_CHAT_TITLE';
export const UPDATE_CHAT_TITLE_SUCCESS = 'UPDATE_CHAT_TITLE_SUCCESS';
export const UPDATE_CHAT_TITLE_FAIL = 'UPDATE_CHAT_TITLE_FAIL';
export const UPDATE_CHAT_TITLE_RESET = 'UPDATE_CHAT_TITLE_RESET';

export const ADD_MESSAGE_TO_CHAT = 'ADD_MESSAGE_TO_CHAT';
export const STREAM_MESSAGE_CHUNK = 'STREAM_MESSAGE_CHUNK';
export const STREAM_MESSAGE_COMPLETE = 'STREAM_MESSAGE_COMPLETE';
export const STREAM_MESSAGE_ERROR = 'STREAM_MESSAGE_ERROR';
export const STREAM_MESSAGE_RESET = 'STREAM_MESSAGE_RESET';

// Chat Sharing
export const GET_CHAT_SHARES = 'GET_CHAT_SHARES';
export const GET_CHAT_SHARES_SUCCESS = 'GET_CHAT_SHARES_SUCCESS';
export const GET_CHAT_SHARES_FAIL = 'GET_CHAT_SHARES_FAIL';
export const GET_CHAT_SHARES_RESET = 'GET_CHAT_SHARES_RESET';

export const SHARE_CHAT = 'SHARE_CHAT';
export const SHARE_CHAT_SUCCESS = 'SHARE_CHAT_SUCCESS';
export const SHARE_CHAT_FAIL = 'SHARE_CHAT_FAIL';
export const SHARE_CHAT_RESET = 'SHARE_CHAT_RESET';

export const UPDATE_CHAT_SHARE = 'UPDATE_CHAT_SHARE';
export const UPDATE_CHAT_SHARE_SUCCESS = 'UPDATE_CHAT_SHARE_SUCCESS';
export const UPDATE_CHAT_SHARE_FAIL = 'UPDATE_CHAT_SHARE_FAIL';
export const UPDATE_CHAT_SHARE_RESET = 'UPDATE_CHAT_SHARE_RESET';

export const REMOVE_CHAT_SHARE = 'REMOVE_CHAT_SHARE';
export const REMOVE_CHAT_SHARE_SUCCESS = 'REMOVE_CHAT_SHARE_SUCCESS';
export const REMOVE_CHAT_SHARE_FAIL = 'REMOVE_CHAT_SHARE_FAIL';
export const REMOVE_CHAT_SHARE_RESET = 'REMOVE_CHAT_SHARE_RESET';

export const createChatSuccess = (response) => ({
  type: CREATE_CHAT_SUCCESS,
  response,
});

export const createChatFail = (response) => ({
  type: CREATE_CHAT_FAIL,
  response,
});

export const createChatReset = () => ({
  type: CREATE_CHAT_RESET,
});

export const getChatSuccess = (response) => ({
  type: GET_CHAT_SUCCESS,
  response,
});

export const getChatFail = (response) => ({
  type: GET_CHAT_FAIL,
  response,
});

export const getChatReset = () => ({
  type: GET_CHAT_RESET,
});

export const getAllChatsSuccess = (response) => ({
  type: GET_ALL_CHATS_SUCCESS,
  response,
});

export const getAllChatsFail = (response) => ({
  type: GET_ALL_CHATS_FAIL,
  response,
});

export const getAllChatsReset = () => ({
  type: GET_ALL_CHATS_RESET,
});

export const getChatsByProjectSuccess = (response) => ({
  type: GET_CHATS_BY_PROJECT_SUCCESS,
  response,
});

export const getChatsByProjectFail = (response) => ({
  type: GET_CHATS_BY_PROJECT_FAIL,
  response,
});

export const getChatsByProjectReset = () => ({
  type: GET_CHATS_BY_PROJECT_RESET,
});

export const deleteChatSuccess = (response) => ({
  type: DELETE_CHAT_SUCCESS,
  response,
});

export const deleteChatFail = (response) => ({
  type: DELETE_CHAT_FAIL,
  response,
});

export const deleteChatReset = () => ({
  type: DELETE_CHAT_RESET,
});

export const updateChatTitleSuccess = (response) => ({
  type: UPDATE_CHAT_TITLE_SUCCESS,
  response,
});

export const updateChatTitleFail = (response) => ({
  type: UPDATE_CHAT_TITLE_FAIL,
  response,
});

export const updateChatTitleReset = () => ({
  type: UPDATE_CHAT_TITLE_RESET,
});

export const streamMessageChunk = (chunk) => ({
  type: STREAM_MESSAGE_CHUNK,
  chunk,
});

export const streamMessageComplete = () => ({
  type: STREAM_MESSAGE_COMPLETE,
});

export const streamMessageError = (error) => ({
  type: STREAM_MESSAGE_ERROR,
  error,
});

export const streamMessageReset = () => ({
  type: STREAM_MESSAGE_RESET,
});

export const createChatApi = (data) => {
  return (dispatch) => {
    dispatch({ type: CREATE_CHAT });
    return axios
      .post(`${config.api.base_url}/chats`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(createChatSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(createChatFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const getChatApi = (chatId) => {
  return (dispatch) => {
    dispatch({ type: GET_CHAT });
    return axios
      .get(`${config.api.base_url}/chats/${chatId}`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getChatSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(getChatFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const getAllChatsApi = (params = {}) => {
  return (dispatch) => {
    dispatch({ type: GET_ALL_CHATS });
    return axios
      .get(`${config.api.base_url}/chats`, {
        params,
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getAllChatsSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(getAllChatsFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const getChatsByProjectApi = (projectId, params = {}) => {
  return (dispatch) => {
    dispatch({ type: GET_CHATS_BY_PROJECT });
    return axios
      .get(`${config.api.base_url}/chats/project/${projectId}`, {
        params,
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getChatsByProjectSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(getChatsByProjectFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const deleteChatApi = (chatId) => {
  return (dispatch) => {
    dispatch({ type: DELETE_CHAT });
    return axios
      .post(`${config.api.base_url}/chats/${chatId}/delete`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(deleteChatSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(deleteChatFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const updateChatTitleApi = (chatId, title) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_CHAT_TITLE });
    return axios
      .post(`${config.api.base_url}/chats/${chatId}/title`, { title }, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(updateChatTitleSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(updateChatTitleFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const abortStreamApi = (chatId) => {
  return () => {
    return axios
      .post(`${config.api.base_url}/chats/${chatId}/abort`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .catch((error) => {
        console.error('Abort stream failed:', error);
      });
  };
};

export const streamMessageApi = async (chatId, content, signal, onMessage, onError, onComplete) => {
  try {
    const token = getUserToken();
    const response = await fetch(`${config.api.base_url}/chats/${chatId}/messages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ content }),
      signal,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to send message');
    }

    const reader = response.body?.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      if (signal?.aborted) {
        const abortError = new Error('AbortError');
        abortError.name = 'AbortError';
        throw abortError;
      }

      const { done, value } = await reader.read();
      if (done) {
        onComplete?.();
        break;
      }

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          try {
            const data = JSON.parse(line.slice(6));
            onMessage?.(data);
          } catch (parseError) {
            console.error('Error parsing SSE data:', parseError);
          }
        }
      }
    }
  } catch (error) {
    if (error.name === 'AbortError' || signal?.aborted) {
      console.log('Stream aborted by user');
      onError?.('AbortError');
      return;
    }
    onError?.(error instanceof Error ? error.message : 'Unknown error');
  }
};

// Chat Sharing Action Creators
export const getChatSharesSuccess = (response) => ({
  type: GET_CHAT_SHARES_SUCCESS,
  response,
});

export const getChatSharesFail = (response) => ({
  type: GET_CHAT_SHARES_FAIL,
  response,
});

export const getChatSharesReset = () => ({
  type: GET_CHAT_SHARES_RESET,
});

export const shareChatSuccess = (response) => ({
  type: SHARE_CHAT_SUCCESS,
  response,
});

export const shareChatFail = (response) => ({
  type: SHARE_CHAT_FAIL,
  response,
});

export const shareChatReset = () => ({
  type: SHARE_CHAT_RESET,
});

export const updateChatShareSuccess = (response) => ({
  type: UPDATE_CHAT_SHARE_SUCCESS,
  response,
});

export const updateChatShareFail = (response) => ({
  type: UPDATE_CHAT_SHARE_FAIL,
  response,
});

export const updateChatShareReset = () => ({
  type: UPDATE_CHAT_SHARE_RESET,
});

export const removeChatShareSuccess = (response) => ({
  type: REMOVE_CHAT_SHARE_SUCCESS,
  response,
});

export const removeChatShareFail = (response) => ({
  type: REMOVE_CHAT_SHARE_FAIL,
  response,
});

export const removeChatShareReset = () => ({
  type: REMOVE_CHAT_SHARE_RESET,
});

// Chat Sharing API Actions
export const getChatSharesApi = (chatId) => {
  return (dispatch) => {
    dispatch({ type: GET_CHAT_SHARES });
    return axios
      .get(`${config.api.base_url}/chats/${chatId}/shares`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getChatSharesSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(getChatSharesFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const shareChatApi = (chatId, data) => {
  return (dispatch) => {
    dispatch({ type: SHARE_CHAT });
    return axios
      .post(`${config.api.base_url}/chats/${chatId}/share`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(shareChatSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(shareChatFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const updateChatShareApi = (chatId, userId, data) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_CHAT_SHARE });
    return axios
      .put(`${config.api.base_url}/chats/${chatId}/share/${userId}`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(updateChatShareSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(updateChatShareFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const removeChatShareApi = (chatId, userId) => {
  return (dispatch) => {
    dispatch({ type: REMOVE_CHAT_SHARE });
    return axios
      .delete(`${config.api.base_url}/chats/${chatId}/share/${userId}`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(removeChatShareSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(removeChatShareFail(error.response?.data || error.message));
        throw error;
      });
  };
};

// Processing Status API (non-Redux - direct API call for polling fallback)
export const getChatProcessingStatusApi = async (chatId) => {
  try {
    const response = await axios.get(
      `${config.api.base_url}/chats/${chatId}/processing-status`,
      {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      }
    );
    return response.data?.data?.processingStatus;
  } catch (error) {
    console.error('Failed to get processing status:', error);
    throw error;
  }
};

// SSE reconnection — re-establishes an SSE connection to receive remaining stream events
export const reconnectStreamApi = async (chatId, signal, onMessage, onError, onComplete) => {
  try {
    const token = getUserToken();
    const response = await fetch(`${config.api.base_url}/chats/${chatId}/reconnect-stream`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      signal,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to reconnect stream');
    }

    const reader = response.body?.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      if (signal?.aborted) break;

      const { done, value } = await reader.read();
      if (done) {
        onComplete?.();
        break;
      }

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          try {
            const data = JSON.parse(line.slice(6));
            onMessage?.(data);
          } catch (parseError) {
            console.error('Error parsing reconnect SSE data:', parseError);
          }
        }
      }
    }
  } catch (error) {
    if (error.name === 'AbortError' || signal?.aborted) {
      console.log('Reconnect stream aborted');
      onError?.('AbortError');
      return;
    }
    onError?.(error instanceof Error ? error.message : 'Unknown error');
  }
};

// Message Feedback API (non-Redux - direct API call)
export const updateMessageFeedbackApi = async (chatId, messageId, feedback) => {
  try {
    const response = await axios.put(
      `${config.api.base_url}/chats/${chatId}/messages/${messageId}/feedback`,
      { feedback },
      {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Failed to update feedback:', error);
    throw error;
  }
};
